export default "__VITE_ASSET__BD00JT$f__"